import Loading from 'vue-loading-overlay'
import PaginationNav from '../../../components/PaginationNav.vue'
import PaginationMobile from '../../../components/PaginationMobile.vue'
import axios from 'axios'

import * as config from '@/config.json'
import moment from 'moment/moment'
import TableSkeleton from '../../../components/TableSkeleton.vue'

export default {
  name: 'DeviceHistory',
  components: {
    Loading,
    PaginationNav,
    PaginationMobile,
    TableSkeleton
  },
  data: () => {
    return {
      isLoading: false,
      token: null,
      selectedOptionAplication: null,
      optionsAplications: [],
      selectedOptionSite: null,
      search: null,
      optionsSites: [],
      pagination: {},
      paginationRange: 11,
      deviceHistory: [],
      fieldsDeviceHistory: [
        {
          key: 'siteName',
          label: 'Loja'
        },
        {
          key: 'openDate',
          label: 'Data'
        },
        {
          key: 'deviceDescription',
          label: 'Dispositivo'
        },
        {
          key: 'deviceStatus',
          label: 'Status'
        },
        {
          key: 'deviceNotes',
          label: 'Observação'
        },
        {
          key: 'customerName',
          label: 'Nome Cliente'
        },
        {
          key: 'customerDocument',
          label: 'Documento Cliente'
        },
        {
          key: 'customerPhone',
          label: 'Telefone Cliente'
        },
        {
          key: 'customerEmail',
          label: 'Email Cliente'
        }
      ],
      currentPage: 1,
      perPage: 10,
      selectedOptionDate: 2,
      optionsDate: [
        {
          value: 1,
          text: 'Ontem'
        },
        {
          value: 2,
          text: 'Hoje'
        },
        {
          value: 3,
          text: 'Últimos 7 dias'
        },
        {
          value: 4,
          text: 'Últimos 15 dias'
        },
        {
          value: 5,
          text: 'Últimos 30 dias'
        },
        {
          value: 6,
          text: 'Com Intervalo de Datas'
        }
      ],
      selectedOption: 1,
      options: [
        {
          value: 1,
          text: 'Nome Cliente'
        },
        {
          value: 2,
          text: 'Documento Cliente'
        }
      ],
      startDate: moment(new Date()).format('YYYY-MM-DD'),
      endDate: moment(new Date()).format('YYYY-MM-DD'),
      selectedOptionDevice: null,
      optionsDevices: [],
      totalRecords: 0,
      selectedOptionCompany: null,
      optionsCompany: [],
      isBusy: false
    }
  },
  methods: {
    async navigate(page) {
      await this.getDeviceHistory(page)
    },

    async clearCompany() {
      this.selectedOptionCompany = null
    },

    async clearSites() {
      this.selectedOptionSite = null
      this.getDeviceHistory(this.currentPage)
    },

    async clearDevices() {
      this.selectedOptionDevice = null
      this.getDeviceHistory(this.currentPage)
    },

    async clearSearch() {
      this.search = null
      this.getDeviceHistory(this.currentPage)
    },

    focus(id) {
      if (id === 'filterInput') {
        this.search = ''
      }

      document.getElementById(id).focus()
    },

    async getCompanies() {
      const url = `${config.default.urlBase}/companies/user`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.optionsCompany = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} ${item.name}`
              }
            })
          )

          if (this.optionsCompany.length == 1) {
            if (!this.selectedOptionCompany) {
              this.selectedOptionCompany = this.optionsCompany[0].value
            }

            this.getSitesByUserType(this.selectedOptionCompany)
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.optionsCompany = []
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar as empresas! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getSitesByUserType() {
      const url = `${config.default.urlBase}/sites/user/type`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.optionsSites = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} - ${item.name}`
              }
            })
          )

          if (this.optionsSites.length == 1) {
            this.selectedOptionSite = this.optionsSites[0].value

            await this.getDevicesBySiteId()
          }
        }
      } catch (error) {
        console.log({
          error
        })

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar os sites! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getDevicesBySiteId() {
      const url = `${config.default.urlBase}/devices/site/${this.selectedOptionSite}`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.optionsDevices = await Promise.all(
            response.data.map(item => {
              return {
                value: item.deviceId,
                text: item.description
              }
            })
          )

          if (this.optionsDevices.length == 1) {
            this.selectedOptionDevice = this.optionsDevices[0].value
          }
        }
      } catch (error) {
        console.log({
          error
        })

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }
      }
    },

    async onChangeFilter() {
      this.startDate = null
      this.endDate = null
      this.search = null

      if (this.selectedOption == '0') {
        this.focus('startDate')
      }

      if (this.selectedOption == '1' || this.selectedOption == '2') {
        this.focus('filterInput')
      }

      await this.getDeviceHistory(this.currentPage)
    },

    async buildData(companyId, siteId, deviceId, selectedOption, selectedOptionDate, startDate, endDate, page) {
      const data = {}

      if (companyId) {
        data.companyId = companyId
      }

      if (siteId) {
        data.siteId = siteId
      }

      if (deviceId) {
        data.deviceId = deviceId
      }

      if (selectedOption == 1) {
        if (this.search) {
          data.customerName = this.search
        }
      }

      if (selectedOption == 2) {
        if (this.search) {
          data.customerDocument = this.search
        }
      }

      if (selectedOptionDate == 1) {
        data.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00')
        data.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD 23:59:59')
      }

      if (selectedOptionDate == 2) {
        data.startDate = moment().format('YYYY-MM-DD 00:00:00')
        data.endDate = moment().format('YYYY-MM-DD 23:59:59')
      }

      if (selectedOptionDate == 3) {
        data.startDate = moment().subtract(6, 'days').format('YYYY-MM-DD 00:00:00')
        data.endDate = moment().format('YYYY-MM-DD 23:59:59')
      }

      if (selectedOptionDate == 4) {
        data.startDate = moment().subtract(14, 'days').format('YYYY-MM-DD 00:00:00')
        data.endDate = moment().format('YYYY-MM-DD 23:59:59')
      }

      if (selectedOptionDate == 5) {
        data.startDate = moment().subtract(29, 'days').format('YYYY-MM-DD 00:00:00')
        data.endDate = moment().format('YYYY-MM-DD 23:59:59')
      }

      if (selectedOptionDate == 6) {
        if (startDate != null && endDate != null) {
          data.startDate = moment(startDate).format('YYYY-MM-DD 00:00:00')
          data.endDate = moment(endDate).format('YYYY-MM-DD 23:59:59')
        }
      }

      data.page = page
      data.pageSize = this.perPage

      return data
    },

    async getDeviceHistory(page) {
      this.isBusy = true

      const url = `${config.default.urlBase}/devices/history/search`
      const data = await this.buildData(
        this.selectedOptionCompany,
        this.selectedOptionSite,
        this.selectedOptionDevice,
        this.selectedOption,
        this.selectedOptionDate,
        this.startDate,
        this.endDate,
        page
      )

      try {
        const response = await axios({
          url,
          method: 'post',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isBusy = false

          this.deviceHistory = response.data.items

          this.pagination = response.data
          this.pagination.rowsPerPage = this.perPage
          this.pagination.paginationRange = this.paginationRange

          this.totalRecords = response.data.records
        }
      } catch (error) {
        console.log({
          error
        })

        this.isBusy = false

        this.deviceHistory = []
        this.totalRecords = 0
        this.pagination = {}

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status != 404) {
          await this.$alert(`Ocorreu um erro ao buscar o histórico! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    redirect(ref) {
      this.$router.push(ref)
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type,
        duration: 3000
      })
    }
  },

  async beforeMount() {
    this.isLoading = true
    this.token = sessionStorage.getItem('token')

    this.getCompanies()
    this.getSitesByUserType()
    this.isLoading = false
  }
}
